export const settingsSchema = {
  botName: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 30
    }
  },
  welcomeMessage: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 500
    }
  },
  examplePhraseA: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 100
    }
  },
  examplePhraseB: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 100
    }
  },
  examplePhraseC: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 100
    }
  },
  chatImageLink: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 200
    }
  },
  domain: {
    presence: { allowEmpty: false, message: "is required" },
    format: {
      pattern: /^\s*(?:(?:((\w)|(\*))+(?:-+((\w)|(\*))+)*\.)+[a-z]+)\s*(?:,\s*(?:(?:((\w)|(\*))+(?:-+((\w)|(\*))+)*\.)+[a-z]+)\s*)*$/,
      message: "invalid"
    }
  },
  desktopRight: {
    numericality: true
  },
  desktopBottom: {
    numericality: true
  },
  mobileRight: {
    numericality: true
  },
  mobileBottom: {
    numericality: true
  }
};
